﻿// lazy image
import 'react-lazy-load-image-component/src/effects/black-and-white.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-lazy-load-image-component/src/effects/opacity.css';

import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router';
// contexts
import ReactGA from 'react-ga4';
import { CollapseDrawerProvider } from './contexts/CollapseDrawerContext';
//
import App from './App';
import { AuthProvider } from './contexts/JWTContext';
// ----------------------------------------------------------------------

ReactGA.initialize('G-1MBLPDCFT1');
// ReactGA.send('PageRoot');
ReactGA.send({
  hitType: 'pageview',
  page: window.location.pathname,
  title: 'PageRoot',
});
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <AuthProvider>
    <HelmetProvider>
        <CollapseDrawerProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </CollapseDrawerProvider>
      </HelmetProvider>
  </AuthProvider >
);
